






























































































































































































































/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { zenkakukana, phoneNumber, accountNumber } from '@/utils/Validator'
import { required, maxLength } from 'vuelidate/lib/validators'
import JWTUtils from '@/utils/JWTUtils'
import { closest } from '@/utils/domUtils'
import {
  CustomerRegistrationConfigResponse,
  CustomerRegistrationRequest,
  StockCompanyResponse,
  BankBranchNameResponse, BankNameResponse
} from '@/types/api'
import { Nullable, ParsedErrorResponse } from '@/types/common'
import OnlineService from '@/services/OnlineService'
import StockCompanyService from '@/services/StockCompanyService'
import BankService from '@/services/BankService'
import BankNameHokkokubank from '@/components/organisms/BankNameHokkokubank.vue'
import BankNameOkasan from '@/components/organisms/BankNameOkasan.vue'
import BankNameHamamatsuIwata from '@/components/organisms/BankNameHamamatsuIwata.vue'
import BankNameChukyo from '@/components/organisms/BankNameChukyo.vue'
import BankNameTaiko from '@/components/organisms/BankNameTaiko.vue'
import BankNameTohobank from '@/components/organisms/BankNameTohobank.vue'

type Data = {
  initialized: boolean;
  disabled: boolean;
  config: Nullable<CustomerRegistrationConfigResponse>;
  form: Nullable<CustomerRegistrationRequest> & { selfCheck?: boolean };
  errors: ParsedErrorResponse<CustomerRegistrationRequest>;
  bankName: string;
  inputCustomerCompanyName: boolean;
  financialOccupationIds: Array<number>;
  showStockCompanyList: boolean;
  stockCompanies: Array<StockCompanyResponse>;
  showBankList: boolean;
  banks: Array<BankNameResponse>;
  showBankBranchList: boolean;
  bankBranches: Array<BankBranchNameResponse>;
  companyCode: string;
  bankNameOptions: Array<BankNameResponse>;
  yuuchoHelp: boolean;
};

type OptionType<T> = {
  text: string;
  value: T | null;
};

export default Vue.extend({
  name: 'CustomerRegistration',
  components: {
    'bank-name-hokkokubank': BankNameHokkokubank,
    'bank-name-okasan': BankNameOkasan,
    'bank-name-hamamatsu-iwata': BankNameHamamatsuIwata,
    'bank-name-chukyo': BankNameChukyo,
    'bank-name-taiko': BankNameTaiko,
    'bank-name-tohobank': BankNameTohobank
  },
  mixins: [validationMixin],
  data (): Data {
    return {
      initialized: false,
      disabled: false,
      config: {},
      form: {},
      errors: {},
      bankName: '',
      inputCustomerCompanyName: false,
      financialOccupationIds: [],
      showStockCompanyList: false,
      stockCompanies: [],
      showBankList: false,
      banks: [],
      showBankBranchList: false,
      bankBranches: [],
      companyCode: process.env.VUE_APP_COMPANY_CODE,
      bankNameOptions: [],
      yuuchoHelp: false
    }
  },
  validations: {
    form: {
      phoneNumber: {
        required,
        format: phoneNumber
      },
      occupationId: {
        required
      },
      officeName: {
        customRequired: function (value: string) {
          if (this.$data.inputCustomerCompanyName) {
            if (!value) {
              return false
            }
            return true
          }
          return true
        },
        customMaxLength: function (value: string) {
          if (this.$data.inputCustomerCompanyName) {
            if (value && value.length <= 128) {
              return true
            }
            return false
          }
          return true
        }
      },
      tradeExperienceId: {
        required
      },
      bankName: {
        required,
        maxLength: maxLength(100)
      },
      bankCode: {
        required
      },
      bankBranchName: {
        required,
        maxLength: maxLength(100)
      },
      withdrawalAccountTypeCode: {
        required
      },
      withdrawalAccountNumber: {
        required,
        format: accountNumber
      },
      lastNameKana: {
        required,
        maxLength: maxLength(20),
        zenkakukana
      },
      firstNameKana: {
        required,
        maxLength: maxLength(20),
        zenkakukana
      },
      selfCheck: {
        checked: value => value === true
      }
    }
  },
  computed: {
    ...mapGetters('registerCode', [
      'registerCode'
    ]),
    // 職業のoption作成
    convertedOccupationOptions (): () => Array<OptionType<number>> {
      return () => [{ text: '選択して下さい', value: null } as OptionType<number>]
        .concat(
          (this.config || []).occupations!.map(o => ({ text: o.name, value: o.id })))
    },
    phoneNumberError (): string {
      const phoneNumber = this.$v.form!.phoneNumber!
      if (!phoneNumber.$dirty) {
        return ''
      }
      if (!phoneNumber.required) {
        return '電話番号は必須項目です'
      } else if (!phoneNumber.format) {
        return '電話番号の形式で入力して下さい'
      }
      return this.errors.phoneNumber || ''
    },
    occupationIdError (): string {
      const occupationId = this.$v.form!.occupationId!
      if (!occupationId.$dirty) {
        return ''
      }
      if (!occupationId.required) {
        return '職業は必須項目です'
      }
      return this.errors.occupationId || ''
    },
    isRequiredOfficeName (): boolean {
      return this.inputCustomerCompanyName
    },
    officeNameError (): string {
      const officeName = this.$v.form!.officeName!
      if (!officeName.$dirty) {
        return ''
      }
      if (!officeName.customRequired) {
        return '会社名は必須項目です'
      } else if (!officeName.customMaxLength) {
        return '会社名は128文字以内で入力して下さい'
      }
      return this.errors.officeName || ''
    },
    tradeExperienceIdError (): string {
      const tradeExperienceId = this.$v.form!.tradeExperienceId!
      if (!tradeExperienceId.$dirty) {
        return ''
      }
      if (!tradeExperienceId.required) {
        return '投資経験は必須項目です'
      }
      return this.errors.tradeExperienceId || ''
    },
    bankNameError (): string {
      const bankName = this.$v.form!.bankName!
      const bankCode = this.$v.form!.bankCode!

      if (!bankName.$dirty) {
        return ''
      }
      if (!bankName.required) {
        return '出金時振込先口座は必須項目です'
      } else if (!bankName.maxLength) {
        return '出金時振込先口座は100文字以内で入力して下さい'
      }
      if (!bankCode.required) {
        return '金融機関名を再入力し、表示される候補の中から選択してください。'
      }
      return this.errors.bankName || ''
    },
    bankBranchNameError (): string {
      const bankBranchName = this.$v.form!.bankBranchName!
      if (!bankBranchName.$dirty) {
        return ''
      }
      if (!bankBranchName.required) {
        return '支店名を再入力し、表示される候補の中から選択してください。'
      } else if (!bankBranchName.maxLength) {
        return '支店名は100文字以内で入力して下さい'
      }
      return this.errors.bankBranchName || ''
    },
    withdrawalAccountTypeCodeError (): string {
      const withdrawalAccountTypeCode = this.$v.form!.withdrawalAccountTypeCode!
      if (!withdrawalAccountTypeCode.$dirty) {
        return ''
      }
      if (!withdrawalAccountTypeCode.required) {
        return '口座の種類は必須項目です'
      }
      return this.errors.withdrawalAccountTypeCode || ''
    },
    withdrawalAccountNumberError (): string {
      const withdrawalAccountNumber = this.$v.form!.withdrawalAccountNumber!
      if (!withdrawalAccountNumber.$dirty) {
        return ''
      }
      if (!withdrawalAccountNumber.required) {
        return '口座番号は必須項目です'
      } else if (!withdrawalAccountNumber.format) {
        return '半角数字7桁で入力して下さい'
      }
      return this.errors.withdrawalAccountNumber || ''
    },
    lastNameKanaError (): string {
      const lastNameKana = this.$v.form!.lastNameKana!
      if (!lastNameKana.$dirty) {
        return ''
      }
      if (!lastNameKana.required) {
        return '姓（カナ）は必須項目です'
      } else if (!lastNameKana.maxLength) {
        return '姓（カナ）は20文字以内で入力して下さい'
      } else if (!lastNameKana.zenkakukana) {
        return '姓（カナ）は全角カタカナで入力して下さい'
      }
      return this.errors.lastNameKana || ''
    },
    firstNameKanaError (): string {
      const firstNameKana = this.$v.form!.firstNameKana!
      if (!firstNameKana.$dirty) {
        return ''
      }
      if (!firstNameKana.required) {
        return '名（カナ）は必須項目です'
      } else if (!firstNameKana.maxLength) {
        return '名（カナ）は20文字以内で入力して下さい'
      } else if (!firstNameKana.zenkakukana) {
        return '名（カナ）は全角カタカナで入力して下さい'
      }
      return this.errors.firstNameKana || ''
    },
    selfCheckError (): string {
      const selfCheck = this.$v.form!.selfCheck!
      if (!selfCheck.$dirty) {
        return ''
      }
      return !selfCheck.checked ? '問題なければチェックをつけて下さい' : ''
    }
  },
  created () {
    const { sub: userId } = JWTUtils.getSubject(JWTUtils.get() as string)
    Promise.all([
      OnlineService.customerInfo(userId),
      OnlineService.customerRegistrationConfig()
    ]).then((data) => {
      const customer = data[0]
      const config = data[1]
      // 初期値を設定（すでに登録済みのデータがあっても考慮しない）
      this.bankName = customer.bankName
      this.form = {
        userId: customer.userId,
        phoneNumber: null,
        occupationId: null,
        officeName: null,
        tradeExperienceId: null,
        bankCode: customer.bankCode,
        bankName: customer.bankName,
        bankBranchName: null,
        // 普通預金（デフォルト値）
        withdrawalAccountTypeCode: config.accountTypeOptions[0].value,
        withdrawalAccountNumber: null,
        lastNameKana: null,
        firstNameKana: null,
        selfCheck: false
      }
      this.financialOccupationIds = config.occupations
        .filter(o => o.financial).map(o => o.id)
      this.config = config
      this.initialized = true
      this.bankNameOptions = config.bankNameOptions
    })
  },
  mounted () {
    window.addEventListener('click', this.closeDatalist)
  },
  beforeDestroy () {
    window.removeEventListener('click', this.closeDatalist)
  },
  methods: {
    updateOccupationId (val: number) {
      this.inputCustomerCompanyName = this.financialOccupationIds.includes(val)
      this.$v.form!.occupationId!.$touch()
      this.form.officeName = null
    },
    /**
     * 証券会社名部分一致検索
     */
    searchStockCompanies (e: HTMLElementEvent<HTMLInputElement>): void {
      const value = e.target.value.trim()
      // 入力値は一旦そのままcommitする
      this.form.officeName = e.target.value
      if (!value) {
        return
      }
      this.$store.commit('loadingIgnore', true)
      const params = {
        companyName: value
      }
      StockCompanyService.search(params).then(data => {
        this.stockCompanies = data
        this.showStockCompanyList = true
      }).finally(() => {
        this.$store.commit('loadingIgnore', false)
      })
    },
    selectStockCompany (officeName: string): void {
      this.form.officeName = officeName
      this.showStockCompanyList = false
    },
    /**
     * 銀行検索
     */
    searchBank (e: HTMLElementEvent<HTMLInputElement>): void {
      const bankName = e.target.value.trim()
      // 入力値は一旦そのままcommitする
      this.form.bankName = e.target.value
      if (!bankName) {
        return
      }
      this.$store.commit('loadingIgnore', true)
      const params = {
        bankName
      }
      BankService.search(params).then(data => {
        this.banks = data
        this.showBankList = true
      }).finally(() => {
        this.$store.commit('loadingIgnore', false)
      })
    },
    selectBank (bankCode: string, bankName: string): void {
      this.form.bankCode = bankCode
      this.form.bankName = bankName
      this.showBankList = false
    },
    clearBanks () {
      this.banks = []
    },
    /**
     * 金融機関を手入力した場合にformにbankCodeを設定ための処理。
     * また、一度入力した金融機関名を変更した場合にbankCodeを削除するための処理。
     * form.bankNameとbanks(その他入力検索結果リスト)の突合.banksにあればbankCodeをセット、なければクリアする
     * 「その他」選択時以外はbanks.length=0なので動作しない
     */
    fillBankCode () {
      if (this.form.bankName === null) {
        return
      }
      const bank = this.banks.filter(bank => bank.bankName === this.form.bankName)
      if (bank.length === 1) {
        this.form.bankCode = bank[0].bankCode
        this.showBankList = false
      } else if (this.banks.length > 0) {
        this.form.bankCode = ''
      }
    },
    /**
     * 銀行支店検索
     */
    searchBankBranch (e: HTMLElementEvent<HTMLInputElement>): void {
      const branchName = e.target.value.trim()
      // 入力値は一旦そのままcommitする
      this.form.bankBranchName = e.target.value
      if (!branchName) {
        return
      }
      this.$store.commit('loadingIgnore', true)
      const params = {
        code: this.form.bankCode,
        branchName
      }
      BankService.findBankBranch(params).then(data => {
        this.bankBranches = data
        this.showBankBranchList = true
      }).finally(() => {
        this.$store.commit('loadingIgnore', false)
      })
    },
    selectBankBranch (bankBranchName: string): void {
      this.form.bankBranchName = bankBranchName
      this.showBankBranchList = false
    },
    /**
     * document.body クリック時に、各種datalistを閉じる
     */
    closeDatalist (e: HTMLElementEvent<HTMLElement>): void {
      // detalistを閉じる
      if (!closest(e.target, '.customar-companyName-wrapper')) {
        this.showStockCompanyList = false
      }
      if (!closest(e.target, '.bank-wrapper')) {
        this.showBankList = false
      }
      if (!closest(e.target, '.bankBranch-wrapper')) {
        this.showBankBranchList = false
      }
    },
    submit (): void {
      this.fillBankCode()
      this.$v.form!.$touch()
      if (this.$v.form!.$anyError) {
        return
      }
      this.disabled = true
      this.errors = {}
      const params = { ...this.form }
      // "本人名義であることを確認"は、POST不要なので削除する
      delete params.selfCheck
      params.registerCode = this.registerCode
      OnlineService.customerRegistration(params).then(() => {
        this.$router.push({ name: 'agreementContract' })
      }).catch(errors => {
        this.errors = errors
        this.disabled = false
      })
    },
    seenYuuchoHelpMethod: function (value: boolean) {
      this.yuuchoHelp = value
    },
    clearBankBranchName: function () {
      this.form.bankBranchName = ''
    }
  }
})
